'use strict';

var log = require('../../log/Log').channel('BatteryLevelExtension');

var BatteryLevelExtension = function(ctrl) {
    log.info('initializing');

    var vm = this;
    var controller = ctrl;

    vm.batteryLevel = {};
    vm.batteryLevel.setController = setController;
    vm.batteryLevel.hasLevel = hasLevel;
    vm.batteryLevel.getLevel = getLevel;
    vm.batteryLevel.getIcon = getIcon;
    vm.batteryLevel.isCharging = isCharging;

    function setController(ctrl) {
        controller = ctrl;
    }

    function hasLevel() {
        return angular.isDefined(controller) && controller !== null;
    }

    function getLevel() {
        return controller ? controller.batteryLevel : 0;
    }

    function isCharging() {
        return controller ? controller.isCharging : true;
    }

    function getIcon() {
        if (controller) {
            if (controller.isCharging) {
                return 'charging';
            }
            else {
                if (controller.batteryLevel === 100) {
                    return 'full';
                }
                else if (controller.batteryLevel > 49 &&
                         controller.batteryLevel < 100) {
                    return 'half';
                }
                else if (controller.batteryLevel < 50 &&
                         controller.batteryLevel > 3) {
                    return 'low';
                }
            }            
        }
        return 'empty';
    }
};

module.exports = BatteryLevelExtension;
